/* eslint-disable react/prop-types */
import React from "react";

class PrimeBonifieeMention extends React.Component {
  render() {
    const montantBonification = parseFloat(
      this.props.APIresult?.bonification?.replace(/\s/g, "") || 0,
    );

    // Si montantBonification est <= 0, ne rien rendre
    if (montantBonification <= 0) {
      return null;
    }

    const offre = this.props.APIresult?.Offre;

    return (
      <>
        <p className="paragraph !font-bold">
          <sup>*</sup> Pour tout devis signé au plus tard le 31/01/2026 et pour
          tout travaux réalisés et facturés au plus tard le 31/12/2026.
        </p>
        {(offre === "pompe à chaleur air/eau" ||
          offre === "pompe à chaleur eau/eau") && (
          <p className="paragraph">
            Les montants de prime du coup de pouce chauffage pour les PAC
            AIR/EAU et EAU/EAU sont exclus pour les travaux effectués au sein de
            la résidence secondaire.
          </p>
        )}
      </>
    );
  }
}

export default PrimeBonifieeMention;
